import { ContactForm } from "@/components/ContactForm";
import { Link } from "react-router-dom";
import { Home, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

const Contact = () => {
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleLogout = async () => {
    const { error } = await supabase.auth.signOut();
    if (error) {
      toast({
        variant: "destructive",
        title: "Error",
        description: "Failed to log out. Please try again.",
      });
    } else {
      navigate("/auth");
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="container mx-auto px-4">
        {/* Navigation Header */}
        <div className="py-4 flex justify-between items-center">
          <Link 
            to="/" 
            className="flex items-center gap-2 text-primary hover:text-primary/80 transition-colors"
          >
            <Home className="h-5 w-5" />
            <span>Back Home</span>
          </Link>
          <Button
            variant="ghost"
            onClick={handleLogout}
            className="flex items-center gap-2 text-red-600 hover:text-red-700 hover:bg-red-50"
          >
            <LogOut className="h-4 w-4" />
            Logout
          </Button>
        </div>

        <div className="py-8">
          <div className="text-center mb-8">
            <img 
              src="/lovable-uploads/5eec74f0-15ca-48bd-82cc-444cca13b17c.png" 
              alt="UPnGOTrainerPad Logo" 
              className="mx-auto h-16 mb-4"
            />
            <h1 className="text-4xl font-bold text-primary">Contact Us</h1>
          </div>
          <ContactForm />
        </div>
      </div>
    </div>
  );
};

export default Contact;